import React, { Fragment } from "react";
import { Breadcrumbs, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import moment from 'moment';
import MaterialTable from 'material-table';
import autoBind from 'react-autobind';
import { Query } from "react-apollo";
import { participanteSessoesEncerradasListQuery } from '../../graphql/Sessao';
import environment from '../../environment/environment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EncerradasGravacoesModal from './encerradasGravacoesModal';

const styles = theme => ({
    sessionsListWrapper: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '30px'
    },
    sessionsEnterButtonContainer: {
        display: 'block',
        backgroundColor: 'yellow',
    },
    buttonSession: {
        width: '100%',
        borderRadius: '0',
        marginBottom: '10px',
        backgroundColor: '#5fb54e',
        paddingTop: '15px;',
        paddingBottom: '25px;',
        color: 'black',
        borderColor: '#5fb54e',
        '&:hover': {
            backgroundColor: 'rgba(95, 181, 78, .8)',
            color: 'black',
            borderColor: '#5fb54e',
        }
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    modalWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
});

class PartEncerradas extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            verArquivados: false,
            definicaoSelecionada: null,
            id: null,
            showModalGravacoes: false,
            sessaoSelecionada: null
        }
        autoBind(this);
    }

    render() {
        const { classes } = this.props;
        return (
            <Paper className={classes.root}>
                {this.renderBreadCrumb()}
                <Fragment>
                    {this.renderGridPrincipal()}
                    {this.defineDetalhesDaSessaoModal()}
                </Fragment>
            </Paper >
        );
    }

    defineDetalhesDaSessaoModal() {
        const { showModalGravacoes, sessaoSelecionada } = this.state;
        const { classes } = this.props;

        return (
            <Modal open={showModalGravacoes} onClose={this.handleClose}>
                <div className={classes.modalWrapper}>
                    <EncerradasGravacoesModal session={sessaoSelecionada} handleCloseFnc={this.handleCloseModal} />
                </div>
            </Modal>
        );
    }

    handleCloseModal() {
        this.setState({
            showModalGravacoes: false,
            sessaoSelecionada: null
        });
    }

    doRefetch() {
        if (!this._queryRefetch)
            return;

        this.props.client.clearStore().then (
            () => this._queryRefetch(this._queryVariables ? { variables: this._queryVariables } : {})
        );
    }

    renderGridPrincipal() {
        return (
            <div>
                <Query query={participanteSessoesEncerradasListQuery} fetchPolicy='network-only'>
                    {({ data, loading, error, refetch }) => {
                        if (loading) return 'Carregando ...';
                        if (error) return `Error! ${error.message}`;
                        this._queryRefetch = refetch;

                        const { participanteSessoesEncerradasList } = data;
                        const actions = this.geraActions();

                        return (
                            <MaterialTable
                                actions={actions}
                                columns = {[
                                    { title: "Nome", field: "sessao.nome" },
                                    { title: "Início", type: 'date', render: row => moment(row.sessao.inicio).format("DD/MM/YYYY HH:mm") },
                                    { title: "Fim", type: 'date', defaultSort: 'desc', render: row => moment(row.sessao.fim).format("DD/MM/YYYY HH:mm") },
                                    { title: "Tempo em que fiquei conectado", render: row => environment.formataQuantidadeSegundos(row.tempo_conectado) },
                                ]}
                                data = {participanteSessoesEncerradasList}
                                localization={{
                                    body: {
                                        emptyDataSourceMessage: 'Nenhuma sala encontrada'
                                    },
                                    header: {
                                        actions: 'Ações'
                                    },
                                    toolbar: {
                                        searchPlaceholder: 'Pesquisar',
                                        searchTooltip: 'Pesquisar'
                                    }
                                }}
                                options={{
                                    actionsColumnIndex: -1,
                                    paging: false,
                                    draggable: false
                                }}
                                title = {
                                    'Sessões Encerradas'
                                }
                            />
                        );
                    }}
                </Query>
            </div>
        );
    }

    geraActions() {
        const actions = [];

        actions.push((data) => ({
            hidden: !(data.gravacoes.length > 0 || data.videos.length > 0),
            icon: VisibilityIcon,
            tooltip: 'Detalhes',
            onClick: (event, rowData) => {
                this.setState({
                    sessaoSelecionada: rowData,
                    showModalGravacoes: true
                });
            }
        }));

        return actions;
    }

    renderBreadCrumb() {
        return (
            <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
                <Typography >Participar</Typography>
                <div>Sessões Encerradas</div>
            </Breadcrumbs>
        );
    }

}

export default (withStyles(styles)(PartEncerradas));